import { render, staticRenderFns } from "./devlist.vue?vue&type=template&id=f68c03e0&scoped=true"
import script from "./devlist.vue?vue&type=script&lang=js"
export * from "./devlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68c03e0",
  null
  
)

export default component.exports